module.exports = __webpack_public_path__ + "static/media/th_bg_mobile.0ab556cc.png";